module.exports = __webpack_public_path__ + "static/media/galerija_2021 (15).b8c7108e.jpg";